export default "__VITE_ASSET__lCT3F0Nz__"